// extracted by mini-css-extract-plugin
module.exports = {"button":"FilterCheckbox_button__2k7eh","button-selected":"FilterCheckbox_button-selected__2hY0E","checkbox":"FilterCheckbox_checkbox__1bSOd","icon":"FilterCheckbox_icon__1cYWo"};